import { Component, Vue } from 'vue-property-decorator';
import { getStyleSkinName } from '@/tools/helpers.ts';
import firebase from 'firebase';
import { request } from '@/tools/request.ts';
import { Guid } from "guid-typescript";

@Component<Login>({
  components: {
    //
  },
})
export default class Login extends Vue {
  protected getStyle: any = getStyleSkinName();
  protected baseUrl: string = 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected email: string = '';
  protected password: string = '';
  protected dummyUsers: DummyUser[] = [{
    email: 'leraar@school.nl',
    password: 'secret',
  },{
    email: 'leraar@lexlibris.nl',
    password: 'secret',
  }, {
    email: 'leraar@parnassys.nl',
    password: 'secret',
  }, {
    email: 'leraar@esis.nl',
    password: 'secret',
  }];
  protected loginError: boolean = false;

  public mounted() {
    //
  }

  protected login() {
    this.dummyUsers.some((item: any) => {
      if (this.email === item.email && this.password === item.password) {
        this.loginError = false;
        this.$router.push('/library-registration');
      } else {
        this.loginError = true;
      }
    });
  }

}
interface DummyUser {
  email: string;
  password: string;
}
